import { render, staticRenderFns } from "./trsAboutTalison.vue?vue&type=template&id=7e1ac4cc&scoped=true"
import script from "./trsAboutTalison.vue?vue&type=script&lang=js"
export * from "./trsAboutTalison.vue?vue&type=script&lang=js"
import style0 from "./trsAboutTalison.vue?vue&type=style&index=0&id=7e1ac4cc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e1ac4cc",
  null
  
)

export default component.exports